var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.referralEventType == 'JOB_REFERRAL' ||
      _vm.referralEventType == 'COMPANY_REFERRAL'
  )?_c('div',[(_vm.referralEventType == 'JOB_REFERRAL')?_c('JobReferraldetails'):_vm._e(),(_vm.referralEventType == 'COMPANY_REFERRAL')?_c('CompanyReferral'):_vm._e()],1):_c('container',[(
      _vm.referralEventType == 'APP_REFERRAL' ||
        _vm.referralEventType == 'REFER_FRIEND_REFERRAL'
    )?_c('AppReferral'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }